import { useEffect, useState } from "react";
import Upload_Products from "../../../components/Upload_Products";
import "./CD_SectionOne.scss";
import Des_Products from "../../../components/Des_Products";
import Info_Products from "../../../components/Info_Product";
import { Button, message } from "antd";
import { postProducts } from "../../../services/createProducts/createProducts";
import { getCondition } from "../../../services/headersProducts/headersProducts";
import { getUserByToken } from "../../../services/user/user";
import { getCookie } from "../../../helper/cookie";
import { useNavigate } from "react-router-dom";

function CD_SectionOne() {
  const [images, setImages] = useState([]);
  const [description, setDescription] = useState("");
  const [info, setInfo] = useState({});
  const [conditionList, setConditionList] = useState([]);
  const [userByToken, setUserByToken] = useState([]);
  const token = getCookie("token");
  const navigate = useNavigate();

  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchApi = async () => {
      const contentCondition = await getCondition();
      const contentUserByToken = await getUserByToken(token);
      setConditionList(contentCondition);
      setUserByToken(contentUserByToken);
    };
    fetchApi();
  }, []);

  const getConditionName = (key) => {
    const found = conditionList.find((c) => c.key === key);
    return found ? found.name : "";
  };

  const handlePost = async () => {
    setLoading(true);

    const idProducts = Date.now(); // tạo ID duy nhất

    const finalSize = Array.isArray(info.size)
      ? info.size[info.size.length - 1]
      : info.size;

    // Dữ liệu mini để push vào headers-products.products
    const productMini = {
      idProducts,
      id: idProducts,
      name: info.brand,
      size: finalSize,
      stock: true,
      price_old: Number(info.price),
      sales: Number(info.sales),
      color: info.color,
      condition: getConditionName(info.productCondition),
      thumbnail1: images[0] || "",
      thumbnail2: images[1] || "",
    };

    // Dữ liệu full để push vào /products
    const productFull = {
      ...productMini,
      title: info.title,
      desc: description,
      bag: "",
      heart: "",
      thumbnail3: images[2] || "",
      name_shop: userByToken[0]?.username || "shop_demo",
      avtshop: userByToken[0]?.avatar || "",
      sold: 0,
      status: userByToken[0]?.status || "Hoạt động tuần này",
      comment: [],
    };

    try {
      // info.category = ["Woman", "ao"]
      const res = await postProducts(
        info.category[1], // key dùng đúng
        productMini,
        productFull
      );

      messageApi.open({
        type: "success",
        content: "Đăng sản phẩm thành công!",
      });

      setImages([]);
      setDescription("");
      setInfo({});

      setTimeout(() => {
        navigate("/");
      }, 1300);
    } catch (err) {
      messageApi.open({
        type: "error",
        content: "Đăng sản phẩm thất bại!",
      });
    }
  };

  return (
    <div className="cd-sectionOne">
      <div className="container">
        {contextHolder}
        <div className="cd-sectionOne-wrapper">
          <div className="cd-title">Tạo sản phẩm</div>

          <div className="cd-title-img">Hình ảnh</div>
          <div className="cd-title-img-sub">
            Thêm tối đa 3 ảnh ở định dạng JPG hoặc PNG.
          </div>
          <Upload_Products onChangeImages={setImages} />

          <div className="cd-title-des">Mô tả</div>
          <Des_Products onChangeDescription={setDescription} />

          <div className="cd-title-info">Thông tin</div>
          <Info_Products onChangeInfo={setInfo} />

          <div className="cd-btn-sell">
            <Button
              onClick={handlePost}
              className="btn-sell"
              loading={loading}
              disabled={loading}
            >
              Đăng bán
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CD_SectionOne;
